import { SENTIMENT_STYLE_MAP } from '@terminal/modules/reflexivity-graph/kg-insight-constants';
import { CardPill } from '@terminal/views/insight-feed/components/insight-feed-card/components/card-pill/CardPill';
import clsx from 'clsx';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import styles from './InsightDrawerHeaderContent.module.scss';
import type { InsightDrawerHeaderContentProps } from './insightDrawerHeaderTypes';

export const InsightDrawerHeaderContent = ({
  cardType,
  context,
  publishedAt,
  sentiment,
  title,
  variant = 'default',
}: InsightDrawerHeaderContentProps) => {
  const { t } = useTranslation(['insights']);

  const publishedDate = new Date(publishedAt);
  const contextNode = context ? (
    <p className={variant === 'scenario' ? styles.context : styles.subtitle}>
      {context}
    </p>
  ) : null;

  return (
    <header className={styles.root}>
      <div className={styles.metadataHeader}>
        <div className={styles.metadataTopRow}>
          <div className={styles.insightTypeGroup}>
            <CardPill type={cardType} />
            {sentiment && (
              <>
                <span className={styles.dot} />
                <span
                  className={clsx(
                    styles.sentimentLabel,
                    SENTIMENT_STYLE_MAP[sentiment]
                  )}
                >
                  {/* i18next-extract-mark-context-next-line["positive", "negative", "neutral"]*/}
                  {t('insights:catalystGeneration.metadata.sentiment', {
                    context: sentiment,
                  })}
                </span>
              </>
            )}
          </div>
          <p className={styles.publishedAt}>
            <span>
              {t('insights:catalystGeneration.metadata.publishedWithDate', {
                date: format(publishedDate, 'MMM d, yyyy'),
              })}
            </span>
            <span className={styles.dot} />
            <span>{format(publishedDate, 'h:mm a')}</span>
          </p>
        </div>
        <div className={styles.titleGroup}>
          {variant === 'scenario' && contextNode}
          <h2 className={styles.title}>{title}</h2>
          {variant === 'default' && contextNode}
        </div>
      </div>
    </header>
  );
};
